module.exports = __webpack_public_path__ + "imgs/star-full-circled-yellow.0833bb083d0d3a1e3bc6afdc00347b33.svg";